// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Graph Engine API
 * HTTP API for managing Neo4j graph engines.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface HandlersPatchGraphEngineInternalResult
 */
export interface HandlersPatchGraphEngineInternalResult {
  /**
   *
   * @type {string}
   * @memberof HandlersPatchGraphEngineInternalResult
   */
  error?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersPatchGraphEngineInternalResult
   */
  id?: string;
  /**
   *
   * @type {boolean}
   * @memberof HandlersPatchGraphEngineInternalResult
   */
  success?: boolean;
}

/**
 * Check if a given object implements the HandlersPatchGraphEngineInternalResult interface.
 */
export function instanceOfHandlersPatchGraphEngineInternalResult(
  value: object,
): value is HandlersPatchGraphEngineInternalResult {
  return true;
}

export function HandlersPatchGraphEngineInternalResultFromJSON(
  json: any,
): HandlersPatchGraphEngineInternalResult {
  return HandlersPatchGraphEngineInternalResultFromJSONTyped(json, false);
}

export function HandlersPatchGraphEngineInternalResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlersPatchGraphEngineInternalResult {
  if (json == null) {
    return json;
  }
  return {
    error: json['error'] == null ? undefined : json['error'],
    id: json['id'] == null ? undefined : json['id'],
    success: json['success'] == null ? undefined : json['success'],
  };
}

export function HandlersPatchGraphEngineInternalResultToJSON(
  json: any,
): HandlersPatchGraphEngineInternalResult {
  return HandlersPatchGraphEngineInternalResultToJSONTyped(json, false);
}

export function HandlersPatchGraphEngineInternalResultToJSONTyped(
  value?: HandlersPatchGraphEngineInternalResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    error: value['error'],
    id: value['id'],
    success: value['success'],
  };
}
